// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.PlaceMap-alertContainer-bp988 {
	padding: 10px 15px;
	position: relative;
	text-align: left;
	padding-left: 50px;
	font-size: 18px;
	color: var(--common-primary-black-foreground);
}

.PlaceMap-alertDanger-E20AW {
	background: var(--secondary-bg);
}

.PlaceMap-dangerIcon-wzFyT {
	position: absolute;
	left: 18px;
	top: 11px;
	font-size: 20px;
	-webkit-transform: none;
	    -ms-transform: none;
	        transform: none;
}

.PlaceMap-alertSuccess-m6ynv {
	background: var(--map-success-color);
	color: var(--common-primary-black-foreground);
}

.PlaceMap-successIcon-vvarT {
	color: #8bd275;
	position: absolute;
	left: 18px;
	top: 15px;
	font-size: 20px;
	-webkit-transform: none;
	    -ms-transform: none;
	        transform: none;
}

.PlaceMap-positionRelative-_iPqw {
	position: relative;
}

.PlaceMap-positionAbsolute-EQxC0 {
	position: absolute;
	top: 0px;
	left: 0;
	z-index: 1;
	width: 100%;
}

@media screen and (max-width: 991px) {
	.PlaceMap-tabViewMap-DfD85 {
		height: 75vh !important;
	}
}`, "",{"version":3,"sources":["webpack://./src/components/PlaceMap/PlaceMap.css"],"names":[],"mappings":"AAAA;CACC,kBAAkB;CAClB,kBAAkB;CAClB,gBAAgB;CAChB,kBAAkB;CAClB,eAAe;CACf,6CAA6C;AAC9C;;AAEA;CACC,+BAA+B;AAChC;;AAEA;CACC,kBAAkB;CAClB,UAAU;CACV,SAAS;CACT,eAAe;CACf,uBAAe;KAAf,mBAAe;SAAf,eAAe;AAChB;;AAEA;CACC,oCAAoC;CACpC,6CAA6C;AAC9C;;AAEA;CACC,cAAc;CACd,kBAAkB;CAClB,UAAU;CACV,SAAS;CACT,eAAe;CACf,uBAAe;KAAf,mBAAe;SAAf,eAAe;AAChB;;AAEA;CACC,kBAAkB;AACnB;;AAEA;CACC,kBAAkB;CAClB,QAAQ;CACR,OAAO;CACP,UAAU;CACV,WAAW;AACZ;;AAEA;CACC;EACC,uBAAuB;CACxB;AACD","sourcesContent":[".alertContainer {\n\tpadding: 10px 15px;\n\tposition: relative;\n\ttext-align: left;\n\tpadding-left: 50px;\n\tfont-size: 18px;\n\tcolor: var(--common-primary-black-foreground);\n}\n\n.alertDanger {\n\tbackground: var(--secondary-bg);\n}\n\n.dangerIcon {\n\tposition: absolute;\n\tleft: 18px;\n\ttop: 11px;\n\tfont-size: 20px;\n\ttransform: none;\n}\n\n.alertSuccess {\n\tbackground: var(--map-success-color);\n\tcolor: var(--common-primary-black-foreground);\n}\n\n.successIcon {\n\tcolor: #8bd275;\n\tposition: absolute;\n\tleft: 18px;\n\ttop: 15px;\n\tfont-size: 20px;\n\ttransform: none;\n}\n\n.positionRelative {\n\tposition: relative;\n}\n\n.positionAbsolute {\n\tposition: absolute;\n\ttop: 0px;\n\tleft: 0;\n\tz-index: 1;\n\twidth: 100%;\n}\n\n@media screen and (max-width: 991px) {\n\t.tabViewMap {\n\t\theight: 75vh !important;\n\t}\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"alertContainer": `PlaceMap-alertContainer-bp988`,
	"alertDanger": `PlaceMap-alertDanger-E20AW`,
	"dangerIcon": `PlaceMap-dangerIcon-wzFyT`,
	"alertSuccess": `PlaceMap-alertSuccess-m6ynv`,
	"successIcon": `PlaceMap-successIcon-vvarT`,
	"positionRelative": `PlaceMap-positionRelative-_iPqw`,
	"positionAbsolute": `PlaceMap-positionAbsolute-EQxC0`,
	"tabViewMap": `PlaceMap-tabViewMap-DfD85`
};
module.exports = ___CSS_LOADER_EXPORT___;
